import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  fetchDatastreamList,
  fetchDatastreamVersions,
} from "features/dashboard/store/dashboard.thunk";
import CenterLoading from "components/common/CenterLoading";
import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import { getPathPrefix } from "utils/coreUtils";
import { setSelectedDatastream, resetSelectedDatastream } from "../store";

function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const { list: datastreamList, isLoadingList } = useSelector(
    (state) => state?.datastream
  );
  const companyDetails = useSelector(
    (state) => state.companyUserReducer.companyUserDetailsData
  );
  const userRoleType = companyDetails?.userRoleType;
  const dataStreamConfigIds = companyDetails?.dataStreamConfigIds;
  const companyId = companyDetails?.companyId;

  useEffect(() => {
    const setupDatastream = async () => {
      if (!datastreamList.length) {
        dispatch(fetchDatastreamList(companyId));
      }
    };
    if (companyId) {
      setupDatastream();
    }
    dispatch(resetSelectedDatastream());
  }, [companyId, datastreamList.length, dispatch]);

  const finalDataStreams = useMemo(() => {
    if (userRoleType && userRoleType !== "CA") {
      return datastreamList.filter((e) =>
        dataStreamConfigIds?.includes(e.dataStreamConfigId)
      );
    }

    return datastreamList;
  }, [userRoleType, datastreamList, dataStreamConfigIds]);
  return (
    <>
      <AiccBreadCrumb
        homeLink={getPathPrefix("dashboard")}
        title={t("dashboard.breadCrumb.title")}
        items={t("dashboard.breadCrumb.items", {
          returnObjects: true,
        })}
      />
      <div className="row mx-1 mx-md-0">
        <div className="col-12 col-xl-12 mb-3 mb-lg-5 mt-4 mt-md-0">
          <h4 className=" text-center">{t("dashboard.title")}</h4>
        </div>
        <div className="col-12">
          <div className="dashboard-card-area col-lg-9 mx-auto mb-5">
            <div className="row g-3">
              {isLoadingList ? (
                <CenterLoading />
              ) : finalDataStreams.length > 0 ? (
                finalDataStreams.map((e) => (
                  <div
                    className="col-lg-6 col-md-6 col-12"
                    key={e.dataStreamConfigId}
                  >
                    <div
                      className="h-100"
                      onClick={() => {
                        dispatch(fetchDatastreamVersions(e.dataStreamConfigId))
                          .unwrap()
                          .then(() => {
                            dispatch(
                              setSelectedDatastream({
                                datastream: e,
                              })
                            );
                            navigate(
                              getPathPrefix(
                                "selected-datastream/rule-engine/versions"
                              )
                            );
                          });
                      }}
                    >
                      <div
                        className="card db-card h-100"
                        style={{
                          marginBottom: "unset",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                wordWrap: "break-word",
                                width: "100%",
                              }}
                            >
                              <h4>{e.customDataStreamName}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="align-items-center d-flex justify-content-center text-center text-no-data"
                  style={{
                    height: "60vh",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: t("dashboard.notConfigured"),
                  }}
                ></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
